import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {OnlineAppOnboarding} from "./online_app_onboarding";

export const onlineAppOnboardingLoader = function (options = {}) {
    componentLoader(componentConfig(OnlineAppOnboarding, OnlineAppOnboarding.config.componentTypeKey, OnlineAppOnboarding.config.baseHtmlClass), options);
};
